import React, { useState, useCallback } from 'react';
import { string } from 'prop-types';

import classnames from 'classnames';

import { namespace } from '../constants';
import InfoTextBoxDescription from './info-text-box-description';

/**
 * Componente principal para renderizar un cuadro de texto con título, descripción y funcionalidad de expandir/colapsar.
 * @param {Object} props - Props del componente.
 * @param {string} props.title - Título del cuadro de texto.
 * @param {string} props.description - Descripción que se muestra en el cuadro de texto.
 * @param {string} props.see_less - Texto para el botón "ver menos".
 * @param {string} props.see_more - Texto para el botón "ver más".
 * @param {string} props.layout - Diseño o layout del componente.
 * @returns {React.Element} Componente InfoTextBox.
 */
const InfoTextBox = ({ title, description, see_less, see_more, layout }) => {
  const [collapsed, setCollapsed] = useState(true);

  const handleClick = useCallback(() => {
    setCollapsed((prevState) => !prevState);
  }, []);

  return (
    <div className={classnames(namespace, `${namespace}--${layout}`)}>
      <div className={classnames(`${namespace}__container`, { [`${namespace}__container--is-collapsed`]: collapsed })}>
        <h2 className={`${namespace}__title`}>{title}</h2>
        {description && (
          <InfoTextBoxDescription
            see_less={see_less}
            see_more={see_more}
            handleClick={handleClick}
            collapsed={collapsed}
            description={description}
          />
        )}
      </div>
    </div>
  );
};

InfoTextBox.propTypes = {
  description: string.isRequired,
  layout: string.isRequired,
  see_less: string.isRequired,
  see_more: string.isRequired,
  title: string.isRequired,
};

export default InfoTextBox;
